import RichTextViewer from './RichTextViewer';

export default RichTextViewer;
